import React from 'react';
import IsometricGardenPrototype from '../components/experimental/IsometricGardenPrototype';

/* ═══════════════════════════════════════════════
  DashboardV2  –  Isometric garden test harness
  Visit /dashboard-v2 to preview terrain painting and plant growth.
   ═══════════════════════════════════════════════ */

const DashboardV2 = () => {
  return (
    <div style={{
    background: 'linear-gradient(180deg, #fbf7ef 0%, #f3ecdd 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '48px 16px 80px',
      fontFamily: 'Manrope-Variable, sans-serif',
    }}>
      {/* Title */}
      <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1a1a1a', margin: 0 }}>
        Garden V2 Preview
      </h1>
      <p style={{ fontSize: 13, color: '#6d6559', margin: '6px 0 28px', maxWidth: 760, textAlign: 'center', lineHeight: 1.6 }}>
        Experimental route for the isometric terrain prototype. Paint tiles, evolve the growth chain,
        randomize the scene, and compare the behavior directly with the original HTML garden spec.
      </p>

      <IsometricGardenPrototype />
    </div>
  );
};

export default DashboardV2;
